import * as React from 'react'
import styled from 'styled-components'
import Svg from './Svg'

function BaseComponent(props: any) {
  return (
    <Svg
      width={15}
      height={15}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M9 4v7L4.5 7.5 9 4z" fill="currentColor" />
    </Svg>
  )
}

const SvgTriangleLeft = styled(BaseComponent)`
  outline: none;
`
export default SvgTriangleLeft
